module.exports = __webpack_public_path__ + "img/9788931005080.9dfe871b.jpg";